import styled from 'styled-components';

export const Wrapper = styled.div`
    @media screen and (max-width: 690px) {
        overflow: scroll;
        .MuiStepper-root {
            padding: ${({ theme }) => theme.spacing * 3}px 0;
        }
    }
    .MuiStepIcon-root.MuiStepIcon-active {
        width: 36px;
        height: 36px;
        color: ${({ theme }) => theme.colors.blue};
    }
    .MuiStepLabel-iconContainer {
        padding-right: ${({ theme }) => theme.spacing * 8}px;
        @media screen and (max-width: 690px) {
            padding-right: ${({ theme }) => theme.spacing * 3}px;
        }
    }
    .MuiStepIcon-root {
        width: 36px;
        height: 36px;
        color: #A0AEBE;
        display: flex;
        justify-content: center;
        align-items: center;
        .MuiStepIcon-text {
            font-size: 10px;
            font-weight: bold;
            font-family: 'Lato';
        }
    }
    .MuiStepLabel-label {
        color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
        opacity: .87;
        font-size: 14px;
        font-weight: bold;
    } 
    .MuiStepLabel-label.MuiStepLabel-active, 
    .MuiStepLabel-label.MuiStepLabel-completed {
        font-size: 14px;
        font-weight: bold;
        color: ${({ theme }) => theme.colors.blue};
        opacity: .87;
    }
    .MuiStepIcon-root.MuiStepIcon-completed {
        color: ${({ theme }) => theme.colors.blue};
        border-radius: 50%;
        width: 36px;
        height: 36px;
    }
    .MuiStepConnector-vertical {
        padding: 0;
        margin-left: 17px;
        .MuiStepConnector-lineVertical {
            border-left-width: 2px;
            min-height: 32px;
        }
    }
`;

export const MobileStepper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
`;

interface IconProps {
    active: boolean;
    done: boolean;
}

export const Icon = styled.div<IconProps>`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: red;
    text-align: center;
    line-height: 24px;
    box-sizing: border-box;
    background-color: #A0AEBE;
    color: ${({ theme }) => theme.colors.white};
    font-size: 12px;
    font-weight: bold;
    background-color: ${props => props.active && '#062B54'};
    background-color: ${props => props.done && 'white'};
    border: ${props => props.done && '2px solid #062B54'};
    display: flex;
    justify-content: center;
    align-items: center;
    > svg {
        color: ${({ theme }) => theme.colors.blue};
        width: 16px;
        height: 16px;
    }
`;

interface StepProps {
    step: number;
    active: boolean;
    size?: number | string;
}

export const MobileStep = styled.div<StepProps>`
    display: grid;
    align-items: center;
    grid-template-columns: ${props => props.step !== 4 ? `24px calc((${props.size}px - 120px) / 4)` : '24px'};
    grid-template-rows: 24px 30px;
    grid-row-gap: 8px;
    .line {
        width: 100%;
        height: 2px;
        background-color: ${props => props.active ? '#A0AEBE' : '#062b54'};
    }
    > p {
        margin-left: ${props => props.step !== 0 ? '-10px' : '0'};
        margin-left: ${props => props.step === 4 && '-24px'};
        color: ${({ theme }) => theme.colors.blue};
        font-weight: bold;
        font-size: 12px;
    }
`;
